import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'eddydata-lib';
import { SkeletonModule } from 'primeng/skeleton';
import { ToastModule } from 'primeng/toast';
import { TreeTableModule } from 'primeng/treetable';
import { ReceitaNivelPrevistoArrecadadoRoutingModule } from './receita-nivel-previsto-arrecadado-routing.module';
import { ReceitaNivelPrevistoArrecadadoComponent } from './receita-nivel-previsto-arrecadado.component';
import { ReceitaNivelModule } from 'administrativo-lib';

@NgModule({
  declarations: [
    ReceitaNivelPrevistoArrecadadoComponent,
  ],
  imports: [
    CommonModule,
    ReceitaNivelPrevistoArrecadadoRoutingModule,
    ReceitaNivelModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TreeTableModule,
    SkeletonModule,
    ToastModule,
  ]
})
export class ReceitaNivelPrevistoArrecadadoModule { }
